export default __webpack_public_path__ + "static/media/icon-info.dfa98848.svg";